
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/copilot",
      function () {
        return require("private-next-pages/copilot/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/copilot"])
      });
    }
  